import React, { Component } from "react";
import { Auth } from "aws-amplify";
import {states} from './loginConstants';

import { withStyles,
    Card, CardActions, CardContent,
    Button, Typography, RadioGroup, Radio, FormControlLabel, Link, Grid, CircularProgress } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

const styles = theme => ({
    card: {
        width: 400,
        padding: 30
    },
    cardActions: {
        padding: 16
    },
    title: {
        padding: 15,
        paddingLeft: 0
    },
    back: {
        fontSize: 12
    },
    input: {
        fontSize: 14
    },
    arrow: {
        fontSize: 10
    }
})

export default withStyles(styles)(class Verify extends Component {
    state = {
        handling: false
    }

    handleVerification = event => {
        this.setState({handling: true});
        event.preventDefault();
        const { contact, username, password } = this.props.inputs;
        Auth.signIn({username, password})
            .then(user => {
                Auth.verifyCurrentUserAttribute(contact)
                .then((data) => {
                    this.setState({handling: false});
                    this.props.switchComponent(states.VERIFY_SUBMIT);
                })
                .catch(err => {
                    this.props.openSnackbar(true, "error", "Invalid or empty contact attribute.");
                    this.setState({handling: false});
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({handling: false});
            });
    }

    render() {
        const {classes} = this.props;
        const {handling} = this.state;
        return (<Card className={classes.card}>
            <CardContent>
            <Typography variant="h6" className={classes.title}>
                <b>Account recovery requires verified contact information</b>
            </Typography>

            <RadioGroup value={this.props.inputs.contact} onChange={this.props.handleRadio}>
                <FormControlLabel value="email" control={<Radio />} label="Email"/>
            </RadioGroup>

            </CardContent>

            <CardActions className={classes.cardActions}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography variant="body2">
                            <Link href="#" onClick={() => this.props.switchComponent(states.SIGN_IN)}>
                                <ArrowBack className={classes.arrow}/> <span className={classes.back}>Back to Sign In</span>
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={this.handleVerification}
                            disabled={handling}
                            endIcon={handling ? <CircularProgress size={20}/> : null}
                        >
                            <b>VERIFY</b>
                        </Button>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>)
    }
})